<template>
    <div class="d-inline-block">
        <span class="d-none d-xl-inline-block">{{ $localDate(date) }}</span>
        <span class="d-inline-block d-xl-none">{{ $localDate(date, shortDateFormat) }}</span>
    </div>
</template>

<script>
export default {
    props: {
        date: String
    },

    data() {
        return {
            shortDateFormat: {
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
            }
        }
    }
}
</script>
